export function convertBankAccountToIban(rawValue: string): string | null {
  const value = normalizeBankAccountInput(rawValue);
  if (!value) return null;

  if (isValidIban(value)) {
    return value;
  }

  const slashIndex = value.indexOf('/');
  if (slashIndex <= 0 || slashIndex === value.length - 1) {
    return null;
  }

  const accountPart = value.slice(0, slashIndex);
  const bankPart = value.slice(slashIndex + 1);
  const accountDigits = accountPart.replace(/\D/g, '');
  const bankDigits = bankPart.replace(/\D/g, '');

  if (!accountDigits || accountDigits.length < 6 || accountDigits.length > 16 || bankDigits.length !== 4) {
    return null;
  }

  const bban = `${bankDigits}${accountDigits.padStart(16, '0')}`;
  const checksum = calculateIbanChecksum(bban);
  return `CZ${checksum}${bban}`;
}

export function isValidBankAccountInput(rawValue: string): boolean {
  return convertBankAccountToIban(rawValue) !== null;
}

function normalizeBankAccountInput(value: string): string {
  return value.trim().toUpperCase().replace(/\s+/g, '').replace(/-/g, '');
}

function isValidIban(value: string): boolean {
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(value)) {
    return false;
  }

  const rearranged = `${value.slice(4)}${value.slice(0, 4)}`;
  const numericValue = rearranged.replace(/[A-Z]/g, ch => (ch.charCodeAt(0) - 55).toString());
  return BigInt(numericValue) % BigInt(97) === BigInt(1);
}

function calculateIbanChecksum(bban: string): string {
  const rearranged = `${bban}CZ00`;
  const numericValue = rearranged.replace(/[A-Z]/g, ch => (ch.charCodeAt(0) - 55).toString());
  const remainder = BigInt(numericValue) % BigInt(97);
  return (BigInt(98) - remainder).toString().padStart(2, '0');
}
